import type { VehicleMakeEntry } from '@/utils/sitemap/parse-vehicle-makes';
import type { SitemapQueryResult } from '@tac/sanity-client/types';
import { groupSafetyFeatureLinks } from '@/utils/sitemap/group-safety-feature-links';

const generateSitemapLinks = ({
  sanityPages,
  vehicleMakesEntries,
}: {
  sanityPages: SitemapQueryResult;
  vehicleMakesEntries: VehicleMakeEntry[];
}) => {
  const siteMapItems = {
    sanityPages: groupSafetyFeatureLinks(sanityPages),
    vehicleMakesEntries: vehicleMakesEntries.map((item) => {
      return {
        title: item.title,
        url: item.pathname,
      };
    }),
  };

  return siteMapItems;
};

export { generateSitemapLinks };
